"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = require("./constants/index");
function default_1(mask, maskChar, formatChars) {
    var parsedMaskString = "";
    var prefix = "";
    var lastEditablePosition = null;
    var permanents = [];
    if (maskChar === undefined) {
        maskChar = index_1.defaultMaskChar;
    }
    if (formatChars == null) {
        formatChars = index_1.defaultFormatChars;
    }
    if (!mask || typeof mask !== "string") {
        return {
            maskChar: maskChar,
            formatChars: formatChars,
            mask: null,
            prefix: null,
            lastEditablePosition: null,
            permanents: []
        };
    }
    var isPermanent = false;
    mask.split("").forEach(function (character) {
        if (!isPermanent && character === "\\") {
            isPermanent = true;
        }
        else {
            if (isPermanent || !formatChars[character]) {
                permanents.push(parsedMaskString.length);
                if (parsedMaskString.length === permanents.length - 1) {
                    prefix += character;
                }
            }
            else {
                lastEditablePosition = parsedMaskString.length + 1;
            }
            parsedMaskString += character;
            isPermanent = false;
        }
    });
    return {
        maskChar: maskChar,
        formatChars: formatChars,
        prefix: prefix,
        mask: parsedMaskString,
        lastEditablePosition: lastEditablePosition,
        permanents: permanents
    };
}
exports.default = default_1;
